import { render, staticRenderFns } from "./QueueGroupForm.vue?vue&type=template&id=8712de36&scoped=true&"
import script from "./QueueGroupForm.vue?vue&type=script&lang=js&"
export * from "./QueueGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8712de36",
  null
  
)

export default component.exports